import { encrypt, decrypt, SECURE_STORAGE_KEYS } from './security';

/**
 * A secure wrapper for localStorage that automatically encrypts/decrypts sensitive keys
 */
export const secureStorage = {
  /**
   * Set item in localStorage with encryption if sensitive
   */
  setItem: (key: string, value: string): void => {
    try {
      const valueToStore = SECURE_STORAGE_KEYS.includes(key) 
        ? encrypt(value) 
        : value;
      localStorage.setItem(key, valueToStore);
    } catch (error) {
      console.error(`Error setting secure item ${key}:`, error);
      localStorage.setItem(key, value);
    }
  },

  /**
   * Get item from localStorage with decryption if sensitive
   */
  getItem: (key: string): string | null => {
    try {
      const value = localStorage.getItem(key);
      if (value && SECURE_STORAGE_KEYS.includes(key)) {
        const decrypted = decrypt(value);
        
        // Migration: If the value was plain-text (decrypted === value) 
        // and it's a sensitive key, we should encrypt it now for future safety.
        if (decrypted === value && value.length > 0 && !value.startsWith('U2FsdGVkX1')) {
          // Note: Only re-encrypt if it doesn't look like it's already encrypted
          // CryptoJS AES standard prefix is 'Salted__' (U2FsdGVkX1 in Base64)
          secureStorage.setItem(key, value);
        }
        
        return decrypted;
      }
      return value;
    } catch (error) {
      return localStorage.getItem(key);
    }
  },

  /**
   * Remove item from localStorage
   */
  removeItem: (key: string): void => {
    localStorage.removeItem(key);
  },

  /**
   * Clear all items from localStorage
   */
  clear: (): void => {
    localStorage.clear();
  }
};
